/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountMemberSchema } from "./accountMemberSchema.ts";
import { groupDataSchema } from "./groupDataSchema.ts";
import { z } from "zod";

export const accountMemberRoleSchema = z.lazy(() => accountMemberSchema).and(z.object({
      "groups": z.array(z.lazy(() => groupDataSchema).describe("Liste des logiciels attribués au membre dans l'organisation")).describe("Liste des logiciels attribués au membre dans l'organisation").optional()
      }))